<template>
  <tr class="extra-cost-row">
    <td>
      {{ extraCost.name }}
    </td>
    <td>
      <div class="text-center">
        <span v-if="parseInt(extraCost.cost)">
          {{ extraCost.cost | to_dollar_amount }}
        </span>
        <span v-else>n/a</span>
      </div>
    </td>
    <td>
      <div class="text-center">
        <span v-if="parseInt(extraCost.hourlyRate)">
          {{ extraCost.hourlyRate | to_dollar_amount }}
        </span>
        <span v-else>n/a</span>
      </div>
    </td>
    <td>
      <div class="text-center">
        <span v-if="parseInt(extraCost.dailyRate)">
          {{ extraCost.dailyRate | to_dollar_amount }}
        </span>
        <span v-else>n/a</span>
      </div>
    </td>
    <td>
      <div class="text-center">
        <span v-if="parseInt(extraCost.overnightRate)">
          {{ extraCost.overnightRate | to_dollar_amount }}
        </span>
        <span v-else>n/a</span>
      </div>
    </td>
    <td>
      <div class="text-center">
        <span v-if="parseInt(extraCost.weekendRate)">
          {{ extraCost.weekendRate | to_dollar_amount }}
        </span>
        <span v-else>n/a</span>
      </div>
    </td>
    <td>
      <router-link v-if="isFinanceAdmin" class="btn btn-sm btn-primary" :to="'/membership/rates/extras/edit/' + extraCost.uuid">
        <span class="fa fa-edit fa-fw"></span> Edit
      </router-link>
      <button v-else disabled class="btn btn-default">
        <span class="fa fa-edit fa-fw"></span> Edit
      </button>
    </td>
  </tr>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'ExtraCostRow',
  props: {
    object: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  computed: {
    ...mapGetters([
      'isFinanceAdmin'
    ]),
    extraCost () {
      return {
        name: '',
        description: '',
        cost: '',
        dailyRate: '',
        hourlyRate: '',
        weekendRate: '',
        defaultRate: false,
        extraCostType: 'extraCost',
        CarClass: {
          name: ''
        },
        ...this.object
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/rows/ExtraCost.vue